"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

/** Hook for triggering a callback when the escape key is pressed */
var useEscapeClose = function useEscapeClose(callback) {
  var close = (0, _react.useCallback)(function (evt) {
    if (evt.keyCode && evt.keyCode === 27) {
      callback(evt);
    } else if (!evt.keyCode) {
      callback(evt);
    }
  }, [callback]);
  (0, _react.useEffect)(function () {
    document.body.addEventListener("keyup", close);
    return function () {
      document.body.removeEventListener("keyup", close);
    };
  }, [close]);
  return close;
};

var _default = useEscapeClose;
exports["default"] = _default;